/**
 * Leviathan Web - API Configuration
 * Quasar Prime LLC
 *
 * Centralized API URL configuration.
 * In development, Vite proxy handles /api routes (see vite.config.ts).
 * In production, set VITE_API_URL to the API server origin.
 */

/// <reference types="vite/client" />

export const API_URL = import.meta.env.VITE_API_URL || '';
